/* ===========================
   TOPLYN Theme — Smooth Scroll & Animations
   Uses Lenis for buttery smooth scrolling
   Uses GSAP ScrollTrigger for scroll-based animations
   =========================== */

(function() {
  var lenis;

  function init() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      setTimeout(init, 100);
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    /* ===========================
       Lenis Smooth Scroll
       =========================== */
    if (typeof Lenis !== 'undefined') {
      lenis = new Lenis({
        duration: 1.2,
        easing: function(t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
        orientation: 'vertical',
        gestureOrientation: 'vertical',
        smoothWheel: true,
        wheelMultiplier: 1,
        touchMultiplier: 2
      });

      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add(function(time) { lenis.raf(time * 1000); });
      gsap.ticker.lagSmoothing(0);
    }

    /* ===========================
       Header — adaptive color based on background
       =========================== */
    var header = document.querySelector('.header-section');
    if (header) {
      var headerH = header.offsetHeight || 64;

      var heroEl = document.querySelector('.hero-slider');
      if (heroEl) {
        ScrollTrigger.create({
          trigger: heroEl,
          start: 'top top',
          end: 'bottom top',
          onLeave: function() {
            header.classList.remove('is-transparent', 'is-over-dark');
            header.classList.add('is-solid');
          },
          onEnterBack: function() {
            header.classList.remove('is-solid', 'is-over-dark');
            header.classList.add('is-transparent');
          }
        });
      }

      document.querySelectorAll('.gallery-slider, .sticky-headline, .community, footer, .footer').forEach(function(section) {
        ScrollTrigger.create({
          trigger: section,
          start: 'top ' + headerH + 'px',
          end: 'bottom ' + headerH + 'px',
          onEnter: function() { header.classList.remove('is-solid'); header.classList.add('is-over-dark'); },
          onLeave: function() { header.classList.remove('is-over-dark'); header.classList.add('is-solid'); },
          onEnterBack: function() { header.classList.remove('is-solid'); header.classList.add('is-over-dark'); },
          onLeaveBack: function() { header.classList.remove('is-over-dark'); header.classList.add('is-solid'); }
        });
      });
    }

    /* ===========================
       Section reveal — NO pre-hiding
       Uses gsap.from() which only animates when triggered
       Sections remain visible by default (no opacity:0 set)
       =========================== */
    /* Sections animate Y only — no opacity hiding to prevent invisible sections */
    document.querySelectorAll(
      '.about-intro, .featured-products, .footer-marquee, .gallery-slider, .sticky-headline, .community, footer'
    ).forEach(function(el) {
      if (el.getBoundingClientRect().top < window.innerHeight) return;
      gsap.from(el, {
        y: 50,
        duration: 1,
        ease: 'power3.out',
        scrollTrigger: { trigger: el, start: 'top 93%', once: true }
      });
    });

    /* ===========================
       About intro — parallax image + text slide
       =========================== */
    var aboutImg = document.querySelector('.about-intro__image, .about-intro__image-wrapper img');
    if (aboutImg) {
      gsap.to(aboutImg, {
        yPercent: -12,
        ease: 'none',
        scrollTrigger: { trigger: aboutImg.closest('.about-intro') || aboutImg, start: 'top bottom', end: 'bottom top', scrub: 1.5 }
      });
    }

    var aboutText = document.querySelector('.about-intro__text-wrapper');
    if (aboutText && aboutText.getBoundingClientRect().top > window.innerHeight) {
      gsap.from(aboutText, {
        x: 60, duration: 1.2, ease: 'power3.out',
        scrollTrigger: { trigger: aboutText, start: 'top 82%', once: true }
      });
    }

    /* ===========================
       Featured products heading
       =========================== */
    var featuredH = document.querySelector('.featured-products h2');
    if (featuredH && featuredH.getBoundingClientRect().top > window.innerHeight) {
      gsap.from(featuredH, {
        scale: 0.85, duration: 0.8, ease: 'power2.out',
        scrollTrigger: { trigger: featuredH, start: 'top 88%', once: true }
      });
    }

    /* ===========================
       Link cards — staggered entrance
       =========================== */
    var linkCards = document.querySelectorAll('.link-cards__card');
    if (linkCards.length && linkCards[0].getBoundingClientRect().top > window.innerHeight) {
      gsap.from(linkCards, {
        y: 70, duration: 0.9, stagger: 0.12, ease: 'power3.out',
        scrollTrigger: { trigger: linkCards[0].parentElement, start: 'top 82%', once: true }
      });
    }

    /* ===========================
       Gallery — horizontal drift on scroll
       =========================== */
    var galleryTrack = document.querySelector('[class*="gallery-slider"] [class*="track"]');
    if (galleryTrack) {
      var drift = Math.min(200, (galleryTrack.scrollWidth - galleryTrack.parentElement.offsetWidth) * 0.15);
      if (drift > 10) {
        gsap.to(galleryTrack, {
          x: -drift, ease: 'none',
          scrollTrigger: { trigger: galleryTrack.closest('section') || galleryTrack.parentElement, start: 'top bottom', end: 'bottom top', scrub: 2 }
        });
      }
    }

    /* ===========================
       "WORN WITH INTENTION" — reveal
       =========================== */
    var stickyText = document.querySelector('.sticky-headline__text');
    if (stickyText && stickyText.getBoundingClientRect().top > window.innerHeight) {
      gsap.from(stickyText, {
        y: 80, duration: 1.2, ease: 'power4.out',
        scrollTrigger: { trigger: stickyText, start: 'top 88%', once: true }
      });
    }

    /* ===========================
       Community — giving back parallax + partner cards
       =========================== */
    var givingImg = document.querySelector('.community img');
    if (givingImg) {
      gsap.to(givingImg, {
        yPercent: -10, ease: 'none',
        scrollTrigger: { trigger: givingImg.closest('section') || givingImg.parentElement, start: 'top bottom', end: 'bottom top', scrub: 1.5 }
      });
    }

    var partnerCards = document.querySelectorAll('[class*="community__partner-card"], [class*="partner-card"]');
    if (partnerCards.length && partnerCards[0].getBoundingClientRect().top > window.innerHeight) {
      gsap.from(partnerCards, {
        y: 40, duration: 0.8, stagger: 0.1, ease: 'power3.out',
        scrollTrigger: { trigger: partnerCards[0].parentElement, start: 'top 85%', once: true }
      });
    }

    /* ===========================
       Footer marquee
       =========================== */
    var mqLabel = document.querySelector('.footer-marquee__label');
    if (mqLabel && mqLabel.getBoundingClientRect().top > window.innerHeight) {
      gsap.from(mqLabel, { x: -30, duration: 0.8, ease: 'power2.out', scrollTrigger: { trigger: mqLabel, start: 'top 92%', once: true } });
    }
    var mqContent = document.querySelector('.footer-marquee__content');
    if (mqContent && mqContent.getBoundingClientRect().top > window.innerHeight) {
      gsap.from(mqContent, { y: 15, duration: 0.8, delay: 0.15, ease: 'power2.out', scrollTrigger: { trigger: mqContent, start: 'top 92%', once: true } });
    }

    /* ===========================
       Product card hover
       =========================== */
    document.querySelectorAll('.product-card, .featured-products a[href*="product"]').forEach(function(card) {
      var imgs = card.querySelectorAll('img');
      if (imgs.length < 2) return;
      gsap.set(imgs[1], { opacity: 0 });
      card.addEventListener('mouseenter', function() {
        gsap.to(imgs[0], { opacity: 0, duration: 0.35, ease: 'power1.inOut' });
        gsap.to(imgs[1], { opacity: 1, scale: 1.02, duration: 0.35, ease: 'power1.inOut' });
      });
      card.addEventListener('mouseleave', function() {
        gsap.to(imgs[0], { opacity: 1, duration: 0.35, ease: 'power1.inOut' });
        gsap.to(imgs[1], { opacity: 0, scale: 1, duration: 0.35, ease: 'power1.inOut' });
      });
    });

    ScrollTrigger.refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Judge.me sharp button */
new MutationObserver(function(){document.querySelectorAll('.jdgm-write-rev-link,.jdgm-write-rev-btn').forEach(function(el){el.style.cssText+=';border-radius:0!important;-webkit-border-radius:0!important;background:#000!important;'});}).observe(document.documentElement,{childList:true,subtree:true});

})();
